import { Box, Tooltip } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

interface CategoryInfoTooltipProps {
  description: string;
  example: string;
}

const CategoryInfoTooltip: React.FC<CategoryInfoTooltipProps> = ({
  description,
  example,
}) => {
  return (
    <Tooltip
      title={
        <Box>
          <Box sx={{ fontWeight: 600, mb: 0.5 }}>{description}</Box>
          <Box sx={{ fontSize: "0.75rem", opacity: 0.9 }}>{example}</Box>
        </Box>
      }
      placement="right"
      arrow
    >
      <InfoOutlinedIcon
        onClick={(e) => e.stopPropagation()}
        sx={{
          fontSize: "0.75rem",
          verticalAlign: "super",
          color: "action.active",
          cursor: "help",
          "&:hover": {
            color: "primary.main",
          },
        }}
      />
    </Tooltip>
  );
};

export default CategoryInfoTooltip;
